import { render, staticRenderFns } from "./IllustrationLoading.vue?vue&type=template&id=765c7ff0&"
import script from "./IllustrationLoading.vue?vue&type=script&lang=ts&"
export * from "./IllustrationLoading.vue?vue&type=script&lang=ts&"
import style0 from "./IllustrationLoading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports